import script from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpersonationBanner.vue?vue&type=script&setup=true&lang=ts"

import "./ImpersonationBanner.vue?vue&type=style&index=0&id=40f0b03f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f0b03f"]])

export default __exports__